/*
 * @Author: hzm
 * @Date: 2023-08-21 16:22:09
 * @Description:
 */

import { defineStore } from 'pinia';
// import auth from '@/plugins/auth';
import router from '@/router';
import { getRouters } from '@/api/menu';
import Layout from '@/layout/shopPlatLayout.vue';
import ParentView from 'mroshopcommon/src/components/ParentView/index.vue';
// import InnerLink from '@/layout/components/InnerLink/index.vue';
// 匹配views里面所有的.vue文件

const modules = import.meta.glob('../views/**/*.vue');
export const usePermissionStore = defineStore('permission', {
  state: () => ({
    routes: [],
    addRoutes: [],
    defaultRoutes: [],
    topbarRouters: [],
    sidebarRouters: [],
    cachedViews: ['index', 'point'],
  }),
  getters: {},
  actions: {
    SET_ROUTES(routes) {
      const self = this as any;
      self.addRoutes = routes;
      self.routes = routes;
    },
    SET_DEFAULT_ROUTES(routes) {
      const self = this as any;
      self.defaultRoutes = routes;
    },
    SET_TOPBAR_ROUTES(routes) {
      const self = this as any;
      // 顶部导航菜单默认添加统计报表栏指向首页
      // const index = [
      //   {
      //     path: 'index',
      //     meta: { title: '统计报表', icon: 'dashboard' },
      //   },
      // ]
      self.topbarRouters = routes;
    },
    SET_SIDEBAR_ROUTERS(routes) {
      const self = this as any;
      self.sidebarRouters = routes;
    },
    GenerateRoutes() {
      return new Promise(resolve => {
        // 向后端请求路由数据
        getRouters().then(res => {
          // res?.data && handleParentView(res?.data);
          const sdata = JSON.parse(JSON.stringify(res?.data));
          const rdata = JSON.parse(JSON.stringify(res?.data));
          const sidebarRoutes = filterAsyncRouter(sdata);
          // 处理rdata,如果菜单下面还是菜单,则在中间增加一层parentView
          const rewriteRoutes = filterAsyncRouter(rdata, false, true);
          // console.log('rewriteRoutes: ', rewriteRoutes);
          // const asyncRoutes = filterDynamicRoutes(dynamicRoutes);
          // rewriteRoutes.push();
          // router.addRoutes(asyncRoutes);
          const self = this as any;
          self.SET_ROUTES(rewriteRoutes);
          self.SET_SIDEBAR_ROUTERS(sidebarRoutes);
          self.SET_DEFAULT_ROUTES(sidebarRoutes);
          self.SET_TOPBAR_ROUTES(sidebarRoutes);
          resolve(rewriteRoutes);
        });
      });
    },
  },
});
// 方法:  处理router,如果当前菜单component!='Layout',并且children存在菜单component!='Layout',则在中间增加一层parentView,包裹所有 component!='Layout'的菜单,并且将当前菜单的path赋值给parentView的path,并且将当前菜单的redirect赋值给parentView的redirect。递归处理

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
  return asyncRouterMap.filter(route => {
    if (type && route.children) {
      route.children = filterChildren(route.children);
    }
    if (route.component) {
      // Layout ParentView 组件特殊处理
      if (route.component === 'Layout') {
        route.component = Layout;
        // 如果存在children, 则跳转到第一个children
        if (route.children && route.children.length) {
          route.redirect = route.path + '/' + route.children[0].path;
        }
      } else if (route.component === 'ParentView') {
        route.component = ParentView;
      } else if (route.component === 'InnerLink') {
        route.component = '';
      } else {
        route.component = loadView(route.component);
      }
    }

    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children, route, type);
    } else {
      delete route['children'];
      delete route['redirect'];
    }
    return true;
  });
}

function filterChildren(childrenMap, lastRouter = false) {
  let children = [];
  childrenMap.forEach((el, index) => {
    if (el.children && el.children.length) {
      if (el.component === 'ParentView' && !lastRouter) {
        el.children.forEach(c => {
          c.path = el.path + '/' + c.path;
          if (c.children && c.children.length) {
            children = children.concat(filterChildren(c.children, c));
            return;
          }
          children.push(c);
        });
        return;
      }
    }
    if (lastRouter) {
      el.path = (lastRouter as any).path + '/' + el.path;
    }
    children = children.concat(el);
  });
  return children;
}

// 动态路由遍历，验证是否具备权限
export function filterDynamicRoutes(routes) {
  const res = [];
  routes.forEach(route => {
    if (route.permissions) {
      if (auth.hasPermiOr(route.permissions)) {
        res.push(route);
      }
    } else if (route.roles) {
      if (auth.hasRoleOr(route.roles)) {
        res.push(route);
      }
    }
  });
  return res;
}

export const loadView = view => {
  // console.log('view: ', view)
  // console.log('modules', modules)
  let res;
  for (const path in modules) {
    const dir = path.split('views/')[1].split('.vue')[0];
    // console.log('dir: ', dir)
    if (dir === view) {
      res = () => modules[path]();
    }
  }
  return res;
};

// export const loadView = (view) => {
//   // if (process.env.NODE_ENV === 'development') {
//   //   return (resolve) => require([`@/views/${view}`], resolve)
//   // } else {
//   //   // 使用 import 实现生产环境的路由懒加载
//   //   return () => import(`@/views/${view}`)
//   // }
//   //@ts-ignore
//   return (resolve) => require([`@/views/${view}`], resolve)
// }
